import {Component} from '@angular/core';
/**
 * \@title Input Prefixes and Suffixes
 */
export class InputPrefixSuffixExample { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'input-prefix-suffix-example',
  templateUrl: 'input-prefix-suffix-example.html',
  styleUrls: ['input-prefix-suffix-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputPrefixSuffixExample_tsickle_Closure_declarations() {
/** @type {?} */
InputPrefixSuffixExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputPrefixSuffixExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
